import React from "react";

import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeStyles, withStyles } from "tss-react/mui";

import OjieThumbsUpIcon from "@/components/Icons/OjieThumbsUpIcon";
import { colors } from "@/theme/overrides/colors";
import nutricoachLogo from "@assets/Nutricoach.png";

const useStyles = makeStyles()({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: colors.white,
  },
  logo: {
    position: "absolute",
    top: 20,
    right: 20,
    width: 150,
    height: 50,
    alignSelf: "flex-end",
  },
  content: {
    width: 562,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 12,
  },
  message: {
    width: 482,
    marginBottom: 32,
    fontWeight: 500,
    textAlign: "center",
    color: colors.grey,
  },
  button: {
    marginBottom: 36,
    "& .MuiButton-label": {
      textTransform: "none",
    },
  },
  link: {
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: 700,
    textDecoration: "none",
  },
  divider: {
    marginLeft: 16,
    marginRight: 16,
    backgroundColor: "#C8CED8",
  },
});

const StyledOjieThumbsUpIcon = withStyles(OjieThumbsUpIcon, {
  root: {
    marginBottom: 26,
    width: 130,
    height: 130,
  },
});

const PaymentSuccessfulPage: React.FC = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <div className={classes.root}>
      <img className={classes.logo} src={nutricoachLogo} />
      <StyledOjieThumbsUpIcon />
      <Typography className={classes.title} variant="h4">
        Account Activated!
      </Typography>
      <Typography className={classes.message} variant="caption">
        Hooray! Your account has been successfully reactivated. You can now
        resume accessing NutriCoach and continue your work with clients. Keep up
        the great work!
      </Typography>
      <Button onClick={() => navigate("/")}>Go to dashboard</Button>
    </div>
  );
};

export default PaymentSuccessfulPage;
